import React, { FC, MouseEvent } from 'react';

import classNames from 'classnames';
import { noop } from 'lodash';
import { useTheme } from 'mintel-react-ui';

import { Section, Theme } from '/types';

import styles from './NavItem.scss';

type NavItemProps = {
  section: Section;
  active: boolean;
  passed: boolean;
  scrollTo: (index: number) => void;
  text: string;
  isInSection?: (section: Section) => boolean;
  isSubsection?: boolean;
  onNavigate?: () => void;
  expandedNav?: boolean;
};

const NavItem: FC<NavItemProps> = ({
  section,
  active,
  passed,
  scrollTo,
  text,
  isInSection = (): false => false,
  isSubsection = false,
  onNavigate = noop,
  expandedNav = false,
}) => {
  const theme: Theme = useTheme();
  const isActiveHighlight = !isSubsection && (isInSection(section) || active);

  const handleClick = (e: MouseEvent): void => {
    e.preventDefault();
    scrollTo(section.index);
    onNavigate();
  };

  const handleEnter = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter') {
      e.preventDefault();
      scrollTo(section.index);
      onNavigate();
    }
  };

  return (
    <a
      className={classNames({
        [styles[theme]]: true,
        [styles.item]: true,
        [styles['expanded-nav-item']]: expandedNav,
        [styles['collapsed-nav-item']]: !expandedNav,
        [styles.subsection]: isSubsection,
        [styles.active]: active,
        [styles.passed]: passed,
      })}
      onClick={handleClick}
      href={`#${section.id}`}
      tabIndex={0}
      onKeyDown={handleEnter}
    >
      <div
        className={classNames(styles.text, {
          [styles.activeText]: active,
          [styles.activeHighlight]: isActiveHighlight,
        })}
        title={expandedNav ? text : undefined}
      >
        <span dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </a>
  );
};

export default NavItem;
